import { RoadRage } from "../../RoadRage";
import { Helper } from "../../../dev/utils/Helper";
import { RoadRageSymbolData } from './RoadRageSymbolData';
import { Power4, Bounce, Power3, Power2, Back,gsap } from "gsap";
import { TextStyleOptions } from "../../../dev/setting/text/IText";
import { ParticleController } from "../../independent/particles/ParticleController";
import { FontStyle, FontWeight } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import { ReelBaseSymbol } from '../../../dev/reel/symbol/ReelBaseSymbol';
import { BLEND_MODES } from 'pixi.js';

export enum ScatterSymState {
    ATTENTION,
    IDLE,
    LEVEL_1,
    LEVEL_2,
    LEVEL_3,
    LEVEL_4,
    LEVEL_5,
    BIGWIN,
    HIT,
}

export class RoadRageScatterLamps extends ReelBaseSymbol {

    private readonly _multStyle: TextStyleOptions = {
        fontFamily: "Helvetica",
        fontStyle: FontStyle.ITALIC,
        fontWeight: FontWeight.EXTRA_BOLD,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 8,
        dropShadowDistance: 12,
        fill: [
            "#ffffff",
            "#FFFC00"
        ],
        fontSize: 42,
        miterLimit: 0,
        wordWrap: true,
        wordWrapWidth: 500,
        stroke: "#FF6A00",
        strokeThickness: 2
    };

    private multiplier: PIXI.Text;
    private Particle: ParticleController;

    private lampPath:string = "S/144/";
    private lvlGraphics:string[] = ["G","Y","R","R2","R3"];

    private _lamps: PIXI.Sprite[] = [];
    private _lamps_gfx: PIXI.Sprite[] = [];
    private lampAmount:number = 3;

    public get symbolHeight(): number {
        return this.sizeType.value;
    }

    public get symbolWidht(): number {
        return RoadRageSymbolData.DEFAULT_DIM.WIDTH;
    }

    public get symbolSizeY(): number {
        return (this.symbolHeight * this.scale.y);
    }

    public get symbolSizeX(): number {
        return (this.symbolWidht * this.scale.x);
    }

    constructor(ID: number, state: any, sizeType: number) {
        super(ID, state, sizeType);
        this.init()
    }

    private init(): void {
        for(let l:number = 0; l < this.lampAmount; l++){
            this._lamps.push(this.addChild(this.createLamp(l)));
            this._lamps_gfx.push(this.addChild(this.createLamp(l)));
        }
        this._lamps_gfx.forEach(sp => {
            sp.alpha = 0;
            // sp.blendMode = BLEND_MODES.ADD;
        })
    }

    private createLamp(lvl:number,alpha:number = 0.25):PIXI.Sprite{
        const sp:PIXI.Sprite = new PIXI.Sprite(this.getLampTexture(lvl));
        sp.anchor.set(0.5,0.5);
        sp.alpha = alpha;
        sp.zIndex = this.children.length;
        sp.blendMode = BLEND_MODES.ADD;
        return sp;
    }

    private getLampTexture(lvl:number):PIXI.Texture{
        return RoadRage.assetLoader.getTextures(this.lampPath + this.lvlGraphics[lvl])[0];
    }

    Play(lvl: number, durr: number = 0.25, multValue: number = 1): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline({
            onStart: () => {this.visible = true}
        }), true);
        this._timeLine.fromTo(this, { alpha: 0 }, { alpha: 1, duration: durr / 4 }, 0)

        this._timeLine.fromTo(this.scale, { x: 0.85, y: 0.85 }, { x: 1.15, y: 1.15, duration: durr / 3, ease: Power3.easeOut }, 0)
        this._timeLine.to(this.scale, { x: 1, y: 1, duration: durr / 3 * 2, ease: Bounce.easeOut }, durr / 3)

        return this._timeLine;
    }

    changeState(state:any, instant?:boolean): gsap.core.Timeline | undefined {
        this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline({}), true);
        this.attentionLoop = Helper.setTimeline(this.attentionLoop, new gsap.core.Timeline({}), true);
        switch(state){
            case ScatterSymState.IDLE:
                this.Idle(0.25);
                break;
            case ScatterSymState.LEVEL_1:
                this.basicAttention(0);
                break;
            case ScatterSymState.LEVEL_2:
                this.basicAttention(1);
                break;
            case ScatterSymState.LEVEL_3:
                this.basicAttention(2);
                break;
            case ScatterSymState.LEVEL_4:
                this.extremeAttention(0);
                break;
            case ScatterSymState.LEVEL_5:
                this.extremeAttention(1);
                break;
            default:
                break;
        }
        this._timeLine.timeScale(instant ?  10 : 1);
        return this._timeLine;
    };
    private attentionLoop:gsap.core.Timeline = new gsap.core.Timeline();
    private basicAttention(target:number){
        if(!this._timeLine) return;
        
        //Debug
        this.resetTexture();

        const gfxEndAlpha:number = 0;

        const resetArr:PIXI.Sprite[] = this._lamps.filter((v,i) => i != target);
        const resetGfxArr:PIXI.Sprite[] = this._lamps_gfx.filter((v,i) => i != target);

        this._timeLine.to(resetArr,{alpha:0.25,duration:0.25},0);
        this._timeLine.to([this._lamps[target],...this._lamps_gfx],{alpha:1,duration:0.25},0);
        this._timeLine.to(resetGfxArr, {alpha:0,duration:0.15},0.25);
        this._timeLine.to(this._lamps_gfx[target],{alpha:gfxEndAlpha,duration:0.5},0.25);

        if(target == 2){
            this._timeLine.add(() => {
                this.attentionLoop = Helper.setTimeline(this.attentionLoop, new gsap.core.Timeline({ repeat: -1 }));
                this.attentionLoop.to(this._lamps_gfx[target],{alpha:1,duration:0.25});
                this.attentionLoop.to(this._lamps_gfx[target],{alpha:gfxEndAlpha/2,duration:0.25});
            },0.5)
        }
    }

    private extremeAttention(lvl:number){
        if(!this._timeLine) return;
        
        //Debug
        this.resetTexture();

        const gfxEndAlpha:number = 0.2;
        
        this._lamps[1].texture = this._lamps_gfx[1].texture = this.getLampTexture(3);
        this._lamps[1].texture = this._lamps_gfx[1].texture = this.getLampTexture(3);

        if(lvl === 0){
            const endGfx:PIXI.Sprite[] = [this._lamps_gfx[1],this._lamps_gfx[2]];

            this._timeLine.to(this._lamps[0],{alpha:0.25,duration:0.25},0);
            this._timeLine.to([this._lamps[1],this._lamps[2],...this._lamps_gfx],{alpha:1,duration:0.25},0);

            this._timeLine.to(this._lamps_gfx[0], {alpha:0,duration:0.15},0.25);
            this._timeLine.to(endGfx,{alpha:gfxEndAlpha,duration:0.25},0.25);

            this._timeLine.add(() => {
                this.attentionLoop = Helper.setTimeline(this.attentionLoop, new gsap.core.Timeline({ repeat: -1 }));
                this.attentionLoop.to(endGfx,{alpha:1,duration:0.25});
                this.attentionLoop.to(endGfx,{alpha:gfxEndAlpha/2,duration:0.25});
            },0.5)
        }else{

            this._lamps[0].texture = this._lamps_gfx[0].texture = this.getLampTexture(4);
            this._lamps[0].texture = this._lamps_gfx[0].texture = this.getLampTexture(4);
    
            this._timeLine.to([...this._lamps,...this._lamps_gfx],{alpha:1,duration:0.25},0);
            this._timeLine.to(this._lamps_gfx,{alpha:gfxEndAlpha,duration:0.25},0.25);

            this._timeLine.add(() => {
                this.attentionLoop = Helper.setTimeline(this.attentionLoop, new gsap.core.Timeline({ repeat: -1 }));
                this.attentionLoop.to(this._lamps_gfx,{alpha:1,duration:0.25});
                this.attentionLoop.to(this._lamps_gfx,{alpha:gfxEndAlpha/2,duration:0.25});
            },0.5)
        }

        // const resetArr:PIXI.Sprite[] = this._lamps.filter((v,i) => i != target);
        // const resetGfxArr:PIXI.Sprite[] = this._lamps_gfx.filter((v,i) => i != target);

        // this._timeLine.to(resetArr,{alpha:0.25,duration:0.25},0);
        // this._timeLine.to([this._lamps[target],...this._lamps_gfx],{alpha:1,duration:0.25},0);
        // this._timeLine.to(resetGfxArr, {alpha:0,duration:0.15},0.25);
        // this._timeLine.to(this._lamps_gfx[target],{alpha:gfxEndAlpha,duration:0.5},0.25);
    }

    resetTexture():void{
        for(let i=0;i < this._lamps.length;i++){
            this._lamps[i].texture = this._lamps_gfx[i].texture = this.getLampTexture(i);
        }
    }

    Idle(durr: number) {
        this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline(), true);
        this._lamps_gfx.forEach(sp => {
            if(sp.alpha){
                this._timeLine!.to(sp,{alpha:0,duration:durr},0)
            }
        });
    }

    Stop(duration: number) {
        this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline({ onComplete: () => {this.visible = false} }), true);
        this._timeLine.fromTo(this, { alpha: 1 }, { alpha: 0, duration: duration }, 0);
    }

    remove(): void {
        this.Stop(0.01);
        if (this._timeLine) this._timeLine.totalProgress(1);
        if (this.Particle) this.Particle.remove();
        this.destroy({ children: true });
    }
}